import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
export default [new Extend.Model(Discussion) //
.attribute('wishVoteCount').attribute('wishVoterCount').attribute('wishVotesMine').attribute('isOpenWish').attribute('canWishVote'), new Extend.Model(User) //
.attribute('wishVotesLeft')];